/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Chart_Series_PowerInputs */

const en_ui_chart_series_power = /** @type {(inputs: Ui_Chart_Series_PowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Power (W)`)
};

const de_ui_chart_series_power = /** @type {(inputs: Ui_Chart_Series_PowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leistung (W)`)
};

/**
* | output |
* | --- |
* | "Power (W)" |
*
* @param {Ui_Chart_Series_PowerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_chart_series_power = /** @type {((inputs?: Ui_Chart_Series_PowerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Chart_Series_PowerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_chart_series_power(inputs)
	return de_ui_chart_series_power(inputs)
});